export const isTwoWaySmsEnabled = (user) => {
  const flag = user?.is_two_way_sms_enabled;

  return flag === true || flag === 1 || flag === "1";
};

export const getStoredTwoWaySmsEnabled = () => {
  const rawUser = typeof window !== "undefined" ? localStorage.getItem("users") : null;

  if (!rawUser) {
    return false;
  }

  try {
    return isTwoWaySmsEnabled(JSON.parse(rawUser));
  } catch (error) {
    return false;
  }
};
